import { useCallback, useEffect, useState } from 'react'
import AddressAutocomplete from '../../firstTimeUserExperience/commonCom/AddressAutocomplete'
import { FORM_CONTROLFIELD_TYPES } from '../../../constants/constants';
import { useError } from '../../../utils/context/ErrorContext';
import CustomInputs from '../../common/Inputs';
import { LeaseApplicationCurrentAddressVM, PropertyItemVM, TenantService } from '@propertelligent/client-api';
import { OnboardingForms } from '../../../typings/onboarding';
import NewSelectAuto from '../../tenants/NewSelectAuto';
import DateHelper from '../../../utils/DateHelper';
import { validateZipCode } from '../../../utils/validateHelper';
import apiHelper from '../../../utils/apiHelper';

const CurrentAddress = ({ formData, setFormData, CurrentAddress }) => {
  const [moveOutReason, setMoveOutReason] = useState()
  const { errors, setErrors, errorMessages, setErrorMessages } = useError()
  const [propertyValue, setPropertyvalue] = useState<PropertyItemVM>()

  const setdata = async () => {
    if (!CurrentAddress) return;

    setFormData((prevFormData) => ({
      ...prevFormData,
      CurrentAddress: prevFormData?.CurrentAddress
        ? prevFormData?.CurrentAddress
        : {
          unitNumber: "",
          streetAddress: "",
          city: "",
          state: "",
          zip: "",
          moveOutDate: "",
          moveOutReasonTypeId: undefined,
          // moveOutReasonTypeId: LeaseApplicationMoveOutReasonTypesEnum.BetterNeighborhood,
        } as LeaseApplicationCurrentAddressVM,
    }));
  }

  useEffect(() => {
    setdata()
  }, [CurrentAddress]);

  useEffect(() => {
    if (propertyValue) {
      const updatedAddress = {
        streetAddress: propertyValue?.streetAddress || "",
        city: propertyValue?.city || "",
        state: propertyValue?.state || "",
        zip: propertyValue?.zip || "",
      };

      setFormData((prevData: OnboardingForms) => ({
        ...prevData,
        CurrentAddress: {
          ...prevData.CurrentAddress,
          ...updatedAddress,
        },
      }));

      Object.entries(updatedAddress).forEach(([subKey, value]) => {
        if (value) {
          const errorKey = `${subKey}`;
          setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
          setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
        }
      });
    }
  }, [propertyValue, setFormData]);

  const handleChange = useCallback((key: string, value: string,) => {
    setFormData((prevData: OnboardingForms) => ({
      ...prevData,
      CurrentAddress: {
        ...prevData?.CurrentAddress,
        [key]: value,
      },
    }));
    const errorKey = `${key}`;
    setErrors((prevErrors) => ({ ...prevErrors, [errorKey]: false }));
    setErrorMessages((prevMessages) => ({ ...prevMessages, [errorKey]: "" }));
    // handleRemoveError(key, OnboardingStepsEnums.CurrentAddress, {key: key, });
  }, [setFormData, propertyValue])

  const AddressDetails = [
    {
      id: 3,
      name: "city",
      labelText: "City",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: formData?.city,
      isFormControl: true,
      onBlur: () => { },
      onChange: (e) => {
        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
        handleChange("city", onlyLetters);
      },
      placeholder: "Enter city",
      myClassName: "containerTextField",
      isError: errors?.city,
      errorMessages: errorMessages?.city,
      width: "147px"
    },
    {
      id: 4,
      name: "state",
      labelText: "State",
      type: FORM_CONTROLFIELD_TYPES.TEXT,
      value: formData?.state,
      isFormControl: true,
      onBlur: () => { },
      onChange: (e) => {
        const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
        handleChange("state", onlyLetters);
      },
      placeholder: "Enter state",
      myClassName: "containerTextField",
      isError: errors?.state,
      errorMessages: errorMessages?.state,
      width: "150px"
    },
    {
      id: 5,
      name: "zip",
      labelText: "ZIP Code",
      type: FORM_CONTROLFIELD_TYPES.INTEGER,
      value: formData?.zip,
      isFormControl: true,
      onBlur: () => {
        validateZipCode(
          formData.zip,
          setErrors,
          setErrorMessages
        )
      },
      onChange: (e) => {
        const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 5);
        handleChange("zip", digitsOnly);
      },
      placeholder: "Enter ZIP code",
      myClassName: "containerTextField",
      isError: errors?.billingZipCode,
      errorMessages: errorMessages?.billingZipCode,
      width: "147px",
      maxLength: 5,
    },
  ];

  const getMoveOutReason = () => {
    apiHelper(TenantService.getApiTenantMoveMoveReasonTypes, { showNotification: false })
      .then((res) => {
        setMoveOutReason(res?.data?.success)
      }).catch((err) => { })
  }

  useEffect(() => {
    getMoveOutReason()
  }, [])
  return (
    <div className='onboradAddressContainer'>
      <AddressAutocomplete
        propertyValue={propertyValue}
        setPropertyvalue={setPropertyvalue}
        required={true}
        showSelectedValue={false}
      />
      <div className='d-flex gap-4 address-form-row'>
        <CustomInputs
          id={1}
          name={"unitNumber"}
          labelText={"Unit Number"}
          type={FORM_CONTROLFIELD_TYPES.TEXT}
          value={formData?.unitNumber}
          isFormControl={true}
          onChange={(e) => handleChange("unitNumber", e.target.value)}
          placeholder={"Unit number"}
          myClassName={"containerTextField"}
          isError={errors?.unitNumber}
          errorMessages={errorMessages?.unitNumber}
          width={"80px"}
          required={true}
        />
        <CustomInputs
          id={2}
          name={"streetAddress"}
          labelText={"Street Address"}
          type={FORM_CONTROLFIELD_TYPES.TEXT}
          value={formData?.streetAddress}
          isFormControl={true}
          onChange={(e) => handleChange("streetAddress", e.target.value)}
          placeholder={"Enter street address"}
          myClassName={"containerTextField"}
          isError={errors?.streetAddress}
          errorMessages={errorMessages?.streetAddress}
          width={"260px"}
          required={true}
        />
      </div>

      <div className="d-flex gap-4 address-form-row">
        {AddressDetails?.map((item) => (
          <CustomInputs
            key={item.id}
            name={item.name}
            type={item.type}
            value={item.value}
            labelText={item.labelText}
            isFormControl={item.isFormControl}
            onChange={item.onChange}
            onBlur={item.onBlur}
            placeholder={item.placeholder}
            myClassName={item.myClassName}
            isError={item.isError}
            errorMessages={item.errorMessages}
            width={item?.width}
            required={true}
            maxLength={item?.maxLength}
          />
        ))}
      </div>
      <div className='d-flex gap-4 address-form-row'>
        <NewSelectAuto
          disabled={undefined}
          setDisabled={undefined}
          selected={formData?.moveOutReasonTypeId}
          setSelected={(value) => handleChange("moveOutReasonTypeId", value)}
          setSelectedOption={undefined}
          selectedOption={undefined}
          data={moveOutReason}
          title={"Wait till the data fetches"}
          type="Reason for Moving"
          error={errors.moveOutReasonTypeId}
          setError={() => { }}
          fromContractor={true}
          label={"Reason for Moving"}
          errorMessage={errorMessages.moveOutReasonTypeId}
          width='100%'
          required={true}
        />
        <CustomInputs
          id={6}
          name={"moveOutDate"}
          labelText={"Moving Date"}
          type={FORM_CONTROLFIELD_TYPES.DATE}
          value={DateHelper.convertUTCtoDateTime2(formData?.moveOutDate)}
          isFormControl={true}
          onChange={(e) => handleChange("moveOutDate", e.target.value)}
          placeholder={"Select moving date"}
          myClassName={"containerTextField"}
          isError={errors?.moveOutDate}
          errorMessages={errorMessages?.movingDate}
          width="170px"
          required={true}
        />
      </div>
    </div>
  )
}

export default CurrentAddress